export default __webpack_public_path__ + "static/media/09-nonprofit.e8f155ca.jpg";